module.exports = __webpack_public_path__ + "929a892ade793400ecb7dbaca5330d24.jpg";